import { render, staticRenderFns } from "./ModuleNftManager.vue?vue&type=template&id=40f8baed&"
import script from "./ModuleNftManager.vue?vue&type=script&lang=js&"
export * from "./ModuleNftManager.vue?vue&type=script&lang=js&"
import style0 from "./ModuleNftManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports